import React, { useState } from "react";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import "./qrCode.css";
import BackButton from "../../Composant/Back_Button/back_button.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

function QRCodeGenerator() {
  const [userInput, setUserInput] = useState("");
  const [format, setFormat] = useState("png");
  const [generated, setGenerated] = useState(false);

  const handleGenerate = () => {
    if (userInput.trim() !== "") {
      setGenerated(true);
    } else {
      alert("Veuillez saisir une URL avant de générer un QR code !");
    }
  };

  const handleDownload = () => {
    if (format === "svg") {
      // --- Cas SVG ---
      const svg = document.querySelector("#qrcode svg");
      const serializer = new XMLSerializer();
      const source = serializer.serializeToString(svg);
      const blob = new Blob([source], { type: "image/svg+xml" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${userInput}-qrcode.svg`;
      link.click();
    } else {
      // --- Cas PNG ---
      const canvas = document.querySelector("#qrcode canvas");
      const dataURL = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = `${userInput}-qrcode.png`;
      link.click();
    }
  };

  return (
    <section className="section-qrCode">
      <BackButton link="/portfolio/2" />
      <p className="title_qrCode">QR Code Generator 📷</p>

      <div className="grp-all">
        <div className="grp-process">
          <div className="box-text">
            <h2>Fonctionnement du générateur :</h2>
            <ul className="liste-qrCode">
              <li>Saisir l'adresse URL du lien souhaité</li>
              <li>Choisir le format d'image voulu (SVG ou PNG)</li>
              <li>Cliquez sur le bouton de génération</li>
              <li>Téléchargez le QR Code</li>
            </ul>
          </div>

          <div className="box-input-user-qrcode">
            <div className="input-user-qr-code">
              <label htmlFor="lien-cible">Lien cible :</label>
              <input
                id="lien-cible"
                type="text"
                placeholder="https://exemple.com"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
              />
            </div>

            <div className="input-user-qr-code">
              <label htmlFor="format">Format d'image :</label>
              <select
                id="format"
                value={format}
                onChange={(e) => setFormat(e.target.value)}
              >
                <option value="png">PNG</option>
                <option value="svg">SVG</option>
              </select>
            </div>

            <div>
              <button className="button-qrCode" onClick={handleGenerate}>
                Generate QR Code
              </button>
            </div>
          </div>
        </div>

        {generated && (
          <div className="box-qrCode">
            {format === "svg" ? (
              <div id="qrcode">
                <QRCodeSVG id="qrcode" value={userInput} size={256} />
              </div>
            ) : (
              <div id="qrcode">
                <QRCodeCanvas value={userInput} size={256} />
              </div>
            )}

            <button className="button-qrCode" onClick={handleDownload}>
              <FontAwesomeIcon icon={faDownload} bounce />
              &nbsp;Télécharger le QR Code
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default QRCodeGenerator;
